function initializeNewsletterForms() {
  document.querySelectorAll('form.newsletter').forEach((form) => {
    if (!(form instanceof HTMLFormElement) || form.dataset.newsletterInitialized) return;

    form.dataset.newsletterInitialized = 'true';
    const submitButton = form.querySelector('[data-newsletter-submit]');
    if (!(submitButton instanceof HTMLButtonElement)) return;

    const defaultLabel = submitButton.textContent;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submitButton.disabled || !form.reportValidity()) return;

      submitButton.disabled = true;

      try {
        const response = await fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
        });

        if (!response.ok) throw new Error('Newsletter submission failed.');

        submitButton.textContent = 'Submitted';
        window.setTimeout(() => {
          submitButton.textContent = defaultLabel;
          submitButton.disabled = false;
        }, 3000);
      } catch (error) {
        console.error(error);
        submitButton.disabled = false;
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeNewsletterForms, { once: true });
} else {
  initializeNewsletterForms();
}
